export const state = {
  addPost: {
    postId: '',
    postName: ''
  },
  updatePost: {},
  users: [
    {
      userName: ''
    }
  ],
  post: {
    postId: '',
    postName: '',
    users: [
      {
        userName: ''
      }
    ]
  },
  posts: [],
  allPosts: [],
  exportData: [],
  total: 0,
  selectedPostList: []
}
export const mutations = {
  reversedUsersCheck(state, payload) {
    for (var i = 0; i < state.users.length; i++) {
      if (state.users[i].userId === payload.userId) {
        state.users[i].postPriorityFlag = !state.users[i].postPriorityFlag
        break
      }
    }
  },
  setPosts(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
      state.total = 0
    }
    for (var i = 0; i < response.data['data'].length; i++) {
      if (
        state.selectedPostList.some(
          selectedPost =>
            selectedPost.postId === response.data['data'][i]['postId']
        )
      ) {
        response.data['data'][i]['checked'] = true
      } else {
        response.data['data'][i]['checked'] = false
      }
    }
    state.posts = response.data['data']
    state.total = response.data['header']['total']
  },
  setAllPosts(state, response) {
    if (response.data['data'] === null) {
      response.data['data'] = []
    }
    const allPosts = []
    for (var i = 0; i < response.data['data'].length; i++) {
      allPosts.push({
        postId: response.data['data'][i]['postId'],
        postName: response.data['data'][i]['postName']
      })
    }
    state.allPosts = allPosts
  },
  setExportData(state, response) {
    for (var i = 0; i < response.data['data'].length; i++) {
      let date = new Date(response.data['data'][i]['createDateTime'])
      response.data['data'][i]['createDateTime'] =
        date.getFullYear() +
        '/' +
        (date.getMonth() + 1) +
        '/' +
        date.getDate() +
        ' ' +
        date.toLocaleTimeString()
      date = new Date(response.data['data'][i]['lastUpdateDateTime'])
      response.data['data'][i]['lastUpdateDateTime'] =
        response.data['data'][i]['lastUpdateDateTime'] === null
          ? ''
          : date.getFullYear() +
            '/' +
            (date.getMonth() + 1) +
            '/' +
            date.getDate() +
            ' ' +
            date.toLocaleTimeString()
    }
    state.exportData = response.data['data']
  },
  clearExportData(state) {
    state.exportData = []
  },
  setDetail(state, response) {
    for (let i in response.data['data']) {
      if (response.data['data'][i] === null) {
        response.data['data'][i] = ''
      }
    }
    for (let i = 0; i < response.data['data'][0]['users'].length; i++) {
      response.data['data'][0]['users'][i]['checked'] = true
    }
    state.post = response.data['data'][0]
    state.users = response.data['data'][0]['users']
    state.updatePost = {}
    state.updatePost.postId = state.post.postId
  },
  inputUpdate(state, payload) {
    state.updatePost[payload.name] = payload.value
  },
  inputAddUpdate(state, payload) {
    state.addPost[payload.name] = payload.value
  },
  clearPost(state) {
    state.addPost = {}
  },
  updateSelectedPostList(state, payload) {
    for (var i = 0; i < payload.length; i++) {
      if (
        payload[i].checked &&
        !state.selectedPostList.some(post => post.postId === payload[i].postId)
      ) {
        state.selectedPostList.push(payload[i])
      } else if (
        !payload[i].checked &&
        state.selectedPostList.some(post => post.postId === payload[i].postId)
      ) {
        const deleteIndex = state.selectedPostList.findIndex(
          post => post.postId === payload[i].postId
        )
        state.selectedPostList = state.selectedPostList.toSpliced(
          deleteIndex,
          1
        )
      }
    }
  },
  clearSelectedPostList(state) {
    state.selectedPostList = []
  }
}
export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/belongModules/belongMutation.js